import { IRoute } from '../utils/constants/interfaces';

import { DashboardPage } from '../views/Dashboard/DashboardPage/DashboardPage';
import { LoginPage } from '../views/Login/LoginPage/LoginPage';
import { UserManagerPage } from '../views/Users/UserManagerPage/UserManagerPage';
import { UserEnableLoginPage } from '../views/Users/UserEnableLoginPage/UserEnableLoginPage';
import { ClubMemberManagerPage } from '../views/ClubMembers/ClubMemberManagerPage/ClubMemberManagerPage';
import { ClubMemberAddSearch } from '../views/ClubMembers/ClubMemberAddSearch/ClubMemberAddSearch';

/* ACCOUNT PAGES */
import { MyAccountPage } from '../views/Account/MyAccountPage/MyAccountPage';
import { ForgotPasswordPage } from '../views/ForgotPassword/ForgotPasswordPage/ForgotPasswordPage';
import { FirstTimeSetupPage } from '../views/ForgotPassword/FirstTimeSetupPage/FirstTimeSetupPage';
import { ChangePasswordPage } from '../views/ForgotPassword/ChangePasswordPage/ChangePasswordPage';

/* REPORTS PAGES */
import { WorkHoursReportPage } from '../views/Reports/WorkHoursReportPage/WorkHoursReportPage';
import { PaymentReportPage } from '../views/Reports/PaymentReportPage/PaymentReportPage';
import { InvoiceReportPage } from '../views/Reports/InvoiceReportPage/InvoiceReportPage';
import { MembershipReportPage } from '../views/Reports/MembershipReportPage/MembershipReportPage';
import { AttritionReportPage } from '../views/Reports/AttritionReportPage/AttritionReportPage';

/* BILLING PAGES */
import { ManageInvoicesPage } from '../views/Billing/ManageInvoicesPage/ManageInvoicesPage';

/* DEV TOOLS PAGES */
import { DevToolsHomePage } from '../views/DevTools/DevToolsHomePage/DevToolsHomePage';
import { ApiTestPage } from '../views/DevTools/ApiTestPage/ApiTestPage';
import { StateViewerPage } from '../views/DevTools/StateViewerPage/StateViewerPage';
import { StyleGuidePage } from '../views/DevTools/StyleGuidePage/StyleGuidePage';

/* ERROR PAGES */
import { NotFoundPage } from '../views/Error/NotFoundPage/NotFoundPage';
import { NotAuthorizedPage } from '../views/Error/NotAuthorizedPage/NotAuthorizedPage';
import { TokenExpiredPage } from '../views/Error/TokenExpiredPage/TokenExpiredPage';
import { MembershipTypeManagerPage } from '../views/MembershipTypes/MembershipTypesManagerPage/MembershipTypesManagerPage';
import { SystemCodesManagerPage } from '../views/SystemCodes/SystemCodesManagerPage/SystemCodesManagerPage';
import { FileManagerPage } from '../views/FileManager/FileManagerPage/FileManagerPage';
import { EmailLogManagerPage } from '../views/EmailLogs/EmailLogManagerPage/EmailLogManagerPage';

export const routeMapping: IRoute[] = [
  {
    path: '/',
    element: <DashboardPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />
  },
  {
    path: '/change-password',
    element: <ChangePasswordPage />
  },
  {
    path: '/first-time-setup',
    element: <FirstTimeSetupPage />
  },
  {
    path: '/users',
    element: <UserManagerPage />
  },
  {
    path: '/users/:userId',
    element: <UserManagerPage />
  },
  {
    path: '/users/enable-login',
    element: <UserEnableLoginPage />
  },

  // SYSTEM CODES
  {
    path: '/codes',
    element: <SystemCodesManagerPage />
  },
  {
    path: '/codes/:systemCodeId',
    element: <SystemCodesManagerPage />
  },

  // FILE MANAGER
  {
    path: '/files',
    element: <FileManagerPage />
  },

  // EMAIL LOGS
  {
    path: '/email-logs',
    element: <EmailLogManagerPage />
  },
  {
    path: '/email-logs/:emailLogId',
    element: <EmailLogManagerPage />
  },

  // MEMBERSHIP TYPES
  {
    path: '/membership-types',
    element: <MembershipTypeManagerPage />
  },
  {
    path: '/membership-types/:membershipTypeId',
    element: <MembershipTypeManagerPage />
  },

  // CLUB MEMBERS
  {
    path: '/members',
    element: <ClubMemberManagerPage />
  },
  {
    path: '/members/add',
    element: <ClubMemberAddSearch />
  },
  {
    path: '/members/:clubMemberId',
    element: <ClubMemberManagerPage />
  },

  // REPORTS
  {
    path: '/reports/work-hours-report',
    element: <WorkHoursReportPage />
  },
  {
    path: '/reports/payment-report',
    element: <PaymentReportPage />
  },
  {
    path: '/reports/membership-report',
    element: <MembershipReportPage />
  },
  {
    path: '/reports/attrition-report',
    element: <AttritionReportPage />
  },
  {
    path: '/billing/invoice-report',
    element: <InvoiceReportPage />
  },

  // BILLING
  {
    path: '/billing/invoices',
    element: <ManageInvoicesPage />
  },

  // ACCOUNT
  {
    path: '/account',
    element: <MyAccountPage />
  },

  // DEV TOOLS
  {
    path: '/dev-tools',
    element: <DevToolsHomePage />
  },
  {
    path: '/dev-tools/api',
    element: <ApiTestPage />
  },
  {
    path: '/dev-tools/style-guide',
    element: <StyleGuidePage />
  },
  {
    path: '/dev-tools/state-viewer',
    element: <StateViewerPage />
  },

  // ERROR PAGES
  {
    path: '/not-authorized',
    element: <NotAuthorizedPage />
  },
  {
    path: '/token-expired',
    element: <TokenExpiredPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];
